<template>
  <b-card class="card-custom card-border">
    <div class="text-center py-10 px-6">
      <div class="svg-icon svg-icon-4x mb-7 opacity-50">
        <inline-svg src="media/svg/icons/Code/Error-circle.svg" />
      </div>
      <p class="font-size-h4">
        {{ text }}
      </p>
      <p>
        Please check url and reload this page.
      </p>
    </div>
  </b-card>
</template>

<script>
export default {
  name: 'FailedDataGet',
  props: {
    text: {
      type: String,
      required: false,
      default: () => 'No Data Found',
    },
  },
}
</script>
